import { useState } from "react";
import { Popover, PopoverBody, PopoverHeader } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Popoveroffset50, Popovertitle } from "../../../../Constants/Constants";

const OffsetRight = () => {
  const [popover, setPopover] = useState(false);
  const toggle = () => setPopover(!popover);
  return (
    <>
      <Btn color="secondary" id="PopoverOffset" onClick={toggle}>
        {Popoveroffset50}
      </Btn>
      <Popover placement="right" isOpen={popover} target="PopoverOffset" toggle={toggle} offset={[50, 0]}>
        <PopoverHeader>{Popovertitle}</PopoverHeader>
        <PopoverBody>{"And here's some amazing content. It's very engaging. Right?"}</PopoverBody>
      </Popover>
    </>
  );
};
export default OffsetRight;
